import BottomSheetHeader from '@components/BottomSheetHeader';
import Button from '@components/Button';
import Column from '@components/Column';
import ImageUploader from '@components/ImageUploader';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useInquiryCommentForm from './hooks/useInquiryCommentForm';
import styles
  from './styles.module.scss';

interface Params {
    inquiryId: string;
}

const InquiryCommentBottomSheet: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { inquiryId } = params;
  const {
    content, setContent, fileUrls, setFileUrls, handleCreateComment,
  } = useInquiryCommentForm(inquiryId);
  return (
        <BottomSheet>
            <BottomSheetHeader>
                추가 문의
            </BottomSheetHeader>
            <Column fullWidth
                    spacing={20}
                    className={styles.container} >
                <Column fullWidth spacing={12}>
                    <Text size='lg' fontWeight='bold' color={colors.gray7}>
                        내용
                    </Text>
                    <TextField as='textarea'
                               value={content}
                               onChange={(e) => setContent(e.target.value)}
                               rows={4}
                               placeholder='200자 이내로 내용을 입력해주세요.'
                               maxLength={200}
                               showLength
                    />
                </Column>
                <Column fullWidth spacing={12}>
                    <Text size='lg' fontWeight='bold' color={colors.gray7}>
                        이미지 파일 업로드
                    </Text>
                    <ImageUploader placeholder='10mb 이내의 png, gift, jpeg만 가능합니다.'
                                   maxLength={2}
                                   value={fileUrls}
                                   setValue={setFileUrls} />
                </Column>
                <Button fullWidth className={styles.button}
                        onClick={handleCreateComment} >
                    추가 문의 등록
                </Button>
            </Column>
        </BottomSheet>
  );
};

export default InquiryCommentBottomSheet;
